import { useState, useEffect, useMemo } from "react"
import { useGetRequest } from "../../Utils/hooks/QueryHandler"
import {
    fetchTemporaryFilterData,
} from "../../Utils/helpers/commonhelper"
import {
    getAllCities,
    getAllStates,
    getCountries,
} from "../../Utils/hooks/location"
import useLocalStorageState from "use-local-storage-state"
import { AuthorizationCard } from "../../CommonComponents/AuthorizationCard"
import { CompanyHeader } from "./companyModules/CompanyHeader"
import { CreateCompany } from "../../CommonComponents/CreateCompany"
import { CompanyListing } from "./companyModules/CompanyListing"
import useCommonData from "../../Utils/actions/advanceFilteringAction"
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials"
import { useGlobalState } from "../../Utils/hooks/useFilterQueryValue"
import { CompanyHeaderCards } from "./companyModules/CompanyHeaderCards"

export const Companies = () => {
    // { reloadKey, setShowCreateCompany, highlightId }
    const industryOptions = [
        { value: "Technology", label: "Technology" },
        { value: "Healthcare", label: "Healthcare" },
        { value: "Finance", label: "Finance" },
        { value: "Education", label: "Education" },
        { value: "Manufacturing", label: "Manufacturing" },
        { value: "Retail", label: "Retail" },
        { value: "Real Estate", label: "Real Estate" },
        { value: "Construction", label: "Construction" },
        { value: "Transportation", label: "Transportation" },
        { value: "Food & Beverage", label: "Food & Beverage" },
        { value: "Entertainment", label: "Entertainment" },
        { value: "Consulting", label: "Consulting" },
        { value: "Marketing & Advertising", label: "Marketing & Advertising" },
        { value: "Legal Services", label: "Legal Services" },
        { value: "Insurance", label: "Insurance" },
        { value: "Telecommunications", label: "Telecommunications" },
        { value: "Energy", label: "Energy" },
        { value: "Agriculture", label: "Agriculture" },
        { value: "Automotive", label: "Automotive" },
        { value: "Aerospace", label: "Aerospace" },
        { value: "Pharmaceuticals", label: "Pharmaceuticals" },
        { value: "Banking", label: "Banking" },
        { value: "E-commerce", label: "E-commerce" },
        { value: "Media", label: "Media" },
        { value: "Non-profit", label: "Non-profit" },
        { value: "Government", label: "Government" },
        { value: "Hospitality", label: "Hospitality" },
        { value: "Travel & Tourism", label: "Travel & Tourism" },
        { value: "Sports & Recreation", label: "Sports & Recreation" },
        { value: "Beauty & Wellness", label: "Beauty & Wellness" },
    ]

    const businessTypeOptions = [
        { value: "Sole Proprietorship", label: "Sole Proprietorship" },
        {
            value: "Limited Liability Partnership(LLP)",
            label: "Limited Liability Partnership(LLP)",
        },
        { value: "Private Limited Company", label: "Private Limited Company" },
        { value: "Public Limited Company", label: "Public Limited Company" },
    ]

    const employeeSizeOptions = [
        { value: "1-10", label: "1-10" },
        { value: "11-50", label: "11-50" },
        { value: "51-200", label: "51-200" },
        { value: "201-500", label: "201-500" },
        { value: "501-1000", label: "501-1000" },
        { value: "1001+", label: "1001+" },
    ]

    // Column options configuration - keep for settings dropdown
    const columnOptions = [
        { id: "name", label: "Name", mandatory: true },
        // { id: "website", label: "Website" },
        { id: "industry", label: "Industry" },
        { id: "business_type", label: "Business Type" },
        { id: "owner", label: "Owner" },
        { id: "phone", label: "Contact No." },
        { id: "email", label: "Email" },
        { id: "address", label: "Address" },
        { id: "state", label: "State" },
        { id: "city", label: "City" },
        { id: "zipcode", label: "Zipcode" },
    ]

    const { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType } = useGetEssentials()
    // parsing company metadata
    const companyMetadata = JSON.parse(localStorage.getItem('companyMetadata'))

    // rbac permission object
    const [PERMISSION, _] = useLocalStorageState('permission')

    // New state for offcanvas
    const [showCreateCompany, setShowCreateCompany] = useState(false);
    const [highlightId, setHighlightId] = useState(null);

    const [activeCard, setActiveCard] = useState(null)

    // states to store the filter data
    const [filterStates, setFilterState] = useState([])

    const [tableOffset, setTableOffset] = useState(0)
    const [cardOffset, setCardOffset] = useState(0)

    const [currView, setCurrView] = useState(() => {
        return companyMetadata?.currView || "card"
    })
    const activeOffset = currView === "card" ? cardOffset : tableOffset
    const setActiveOffset = currView === "card" ? setCardOffset : setTableOffset
    const [pageButtons, setPageButtons] = useState([])
    const [search, setSearch] = useState()

    const Limit = currView === "card" ? 24 : 25
    const [limit, setLimit] = useState(Limit)
    const [companies, setCompanies] = useState([])

    // filter categories to render within the heading dropdown
    const [filterCategories, setFilterCategories] = useState([])
    // state to store the advanced custom filter to fetch data on save
    const [customFilter, setCustomFilter] = useState(null)

    const [heading, setHeading] = useState("All Companies")

    const params = useMemo(
        () => ({ limit, offset: activeOffset, search }),
        [limit, activeOffset, search]
    )
    // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
    const [isInitialized, setIsInitialized] = useState(false)

    useEffect(() => {
        if (!isInitialized) {
            const lastHeading = companyMetadata?.filterType?.filterName
            setHeading(lastHeading || "All Companies")
            setIsInitialized(true)
        }
    }, [isInitialized, companyMetadata])

    // Save view preference to localStorage
    useEffect(() => {
        localStorage.setItem("companyMetadata", JSON.stringify(
            {
                ...companyMetadata,
                currView: currView,
            }
        ))
    }, [currView])

    // states for dynamic api calls
    const [showCards, setShowCards] = useState(true)
    // all states for filter field hydration
    const [allState, setAllState] = useState([])
    // all cities for filter field hydration
    const [allCity, setAllCity] = useState([])
    // country state
    const [country, setCountries] = useState([])
    // Initialize columns state from localStorage or default to all visible
    const [columns, setColumns] = useState(() => {
        const saved = companyMetadata?.visibleColumns
        const allColumnKeys = columnOptions.map(col => col.label);
        if (saved) {
            try {
                return saved;
            } catch (e) {
                console.error("Error parsing visible columns:", e);
            }
        }
        return allColumnKeys;
    });

    // company advance filter params and currAdvFilter
    const [companyFilterDataParams, setCompanyFilterDataParams] = useGlobalState('companyFilterDataParams', { currAdvFilter: null, applyFilterData: {} })

    // loading state for temporary filter data to be hydrated
    const [tempFilterDataLoading, setTempFilterDataLoading] = useState(false)
    // curr advance filter to store the current filter type between "apply" and "save as" in advance filter for respective pagination in apply filter
    const [currAdvFilter, setCurrAdvFilter] = useState(companyFilterDataParams?.currAdvFilter || null)

    // state for filter dropdown contacts
    const [filterDropdown, setFilterDropdown] = useState(false)
    // const [filterDropdown, setFilterDropdown] = useState(false)
    const [tempFilterData, setTempFilterData] = useState(null)

    // global value state for applying the pagination to temporary filter data
    const [companyFilterValues, setCompanyFilterValues] = useGlobalState("companyApplyFilterQueryValues")

    // rbac permission grant for company
    const companyGrants = PERMISSION?.company

    const { leadOwner } = useCommonData({
        leadOwner: true,
        leadSource: false,
        companies: false,
        contacts: false
    })
    const applyFilterDataParams = {
        filterValues: companyFilterValues,
        currView: currView,
        offset: activeOffset,
        limit: limit,
        module_name: 'company',
        customerId: customerId,
        loginUserId: loginUserId,
        userType: userType,
        headers: headers,
        extras: extras,
        setTempFilterData: setTempFilterData,
        setLoading: setTempFilterDataLoading,
        setFilterState: setFilterState,
        setFilterDropdown: setFilterDropdown
    }

    // Keep apply-filter params in global state so apply + remount (e.g. after company details) can hydrate
    useEffect(() => {
        setCompanyFilterDataParams({
            currAdvFilter: currAdvFilter,
            applyFilterData: {
                ...applyFilterDataParams,
                filterValues: companyFilterValues,
                currView: currView,
                offset: activeOffset,
                limit: limit,
            }
        })
    }, [currAdvFilter, companyFilterValues, currView, activeOffset, limit])

    // Fixed dropdown options for filtering (matches hardcoded table columns)
    const dropdownOptions = [
        { value: "company_name", label: "Company Name" },
        { value: "website", label: "Website" },
        { value: "industry", label: "Industry", option: industryOptions },
        {
            value: "business_type",
            label: "Business Type",
            option: businessTypeOptions,
        },
        { value: "owner_id", label: "Owner", option: leadOwner },
        { value: "email", label: "Email" },
        { value: "address", label: "Address" },
        { value: "state", label: "State", option: allState },
        { value: "city", label: "City", option: allCity },
        { value: "zipcode", label: "Zipcode" },
        { value: "phone", label: "Phone" },
        { value: "country", label: "Country", option: country },
        {
            value: "employee_size",
            label: "Employee Size",
            option: employeeSizeOptions,
        },
        { value: "status", label: "Status" },
        { value: "rating", label: "Rating" },
        { value: "created_at", label: "Created at", type: "date-range" },
        { value: "added_by", label: "Created By", option: leadOwner },
    ]


    // Helper functions for fetching countries, states, cities, lead owners, and initializing data
    const fetchCountries = async () => {
        try {
            const data = await getCountries()
            if (!data) return
            setCountries(
                data.map((country) => ({
                    label: country.name,
                    value: country.id,
                }))
            )
        } catch (error) {
            // toast.error("Error Fetching Data")
            return
        }
    }

    const fetchStates = async () => {
        try {
            const data = await getAllStates()
            if (!data || data === undefined) {
                setAllState([])
                return
            }
            setAllState(
                data.map((state) => ({
                    label: state.state_name,
                    value: state.id,
                }))
            )
        } catch (error) {
            // toast.error("Error Fetching State")
            return
        }
    }

    const fetchCities = async () => {
        try {
            const data = await getAllCities()
            if (!data || data === undefined) {
                setAllCity([])
                return
            }
            setAllCity(
                data.map((city) => ({
                    label: city.city_name,
                    value: city.id,
                }))
            )
        } catch (error) {
            // toast.error("Error Fetching State")
            return
        }
    }

    const initData = async () => {
        await Promise.all([
            fetchCountries(),
            fetchStates(),
            fetchCities(),
        ])
    }

    // Mount effect to initialize all required data
    useEffect(() => {
        initData()
    }, [])



    useEffect(() => {
        if (currAdvFilter === "apply" && companyFilterValues?.["filter_values"]?.length > 0) {
            fetchTemporaryFilterData(companyFilterDataParams?.applyFilterData)
        }
    }, [
        companyFilterDataParams?.applyFilterData
    ])

    const { endpoint, queryKey } = useMemo(() => {
        if (currAdvFilter === "apply") {
            return {
                endpoint: "",
                queryKey: ""
            }
        }

        // reseting filtervalues if current advance filter is null
        setCompanyFilterValues({ filter_state: [], filter_values: [] })

        const customFilterId = companyMetadata?.filterType?.id

        const lowerHeading = heading.toLowerCase()?.split(" ").join("_")

        if (!customFilter && !customFilterId) {

            if (lowerHeading === "companies_created_by_me") {
                return {
                    endpoint: `company/getCompanyCreatedByMe/${loginUserId}/${customerId}`,
                    queryKey: "companiesCreatedByMe"
                }
            }
            if (lowerHeading === "companies_created_today") {
                return {
                    endpoint: `company/getCompanyCreatedBasedOnDuration/${loginUserId}/${customerId}/today`,
                    queryKey: "companiesCreatedToday"
                }
            }
            if (lowerHeading === "companies_created_this_month") {
                return {
                    endpoint: `company/getCompanyCreatedBasedOnDuration/${loginUserId}/${customerId}/month`,
                    queryKey: "companiesCreatedThisMonth"
                }
            }
            if (lowerHeading === "all_companies" || lowerHeading === null) {
                return {
                    endpoint: `company/fetchAllCompanies/${customerId}/${loginUserId}`,
                    queryKey: "fetchAllCompanies"
                }
            }
        }

        if (customFilter || customFilterId) {
            const id = customFilter?.id || customFilterId
            return {
                endpoint: `company/fetchAllCompanies/${customerId}/${loginUserId}/${id}`,
                queryKey: `filterQuery${id}`
            }
        }
        return {
            endpoint: "",
            queryKey: ""
        }

    }, [
        heading,
        filterCategories,
        customFilter,
        currAdvFilter,
        // companyMetadata?.filterType?.id,
    ])

    const { data, error, refetch, isLoading } = useGetRequest(
        endpoint,
        queryKey,
        headers,
        { customer, setCustomer, rf: headers.Authentication, navigate },
        params
    )

    useEffect(() => {
        if (
            data &&
            data.filter_data &&
            data.filter_data[0] &&
            data.filter_data[0].filter_values
        ) {
            const values = data.filter_data[0].filter_values
            const parsedState = JSON.parse(values)
            const filteredArray = parsedState?.map((state) => {
                // Find the corresponding dropdown option to get the display label and potential nested options
                const dropdownOption = dropdownOptions.find(
                    (opt) => opt.value === state.label_name
                )

                let mappedOptions = null
                if (dropdownOption?.option && Array.isArray(dropdownOption.option)) {
                    // Replicate the mapping logic from handleAddFilter
                    if (dropdownOption.value === "owner_id") {
                        mappedOptions = dropdownOption.option.map((opt) => ({
                            value: opt.leadId,
                            label: opt.leadName,
                        }))
                    } else if (dropdownOption.value === "lead_source_id") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.lead_source_id,
                            label: opt.source_title,
                        }))
                    } else if (dropdownOption.value === "company_id") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.company_id,
                            label: opt.company_name,
                        }))
                    } else if (dropdownOption.value === "country") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.countryId,
                            label: opt.countryName,
                        }))
                    } else if (dropdownOption.value === "state") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.stateCode,
                            label: opt.stateName,
                        }))
                    } else if (dropdownOption.value === "city") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.cityId,
                            label: opt.cityName,
                        }))
                    } else if (dropdownOption.value === "industry") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.value,
                            label: opt.label,
                        }))
                    } else if (dropdownOption.value === "business_type") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.value,
                            label: opt.label,
                        }))
                    } else if (dropdownOption.value === "employee_size") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.value,
                            label: opt.label,
                        }))
                    }
                }
                return {
                    id: state.label_name, // IMPORTANT: Generate a new unique ID for React keys
                    field: state.label_name, // This is the internal identifier (e.g., "email", "owner")
                    label_name: dropdownOption ? dropdownOption.label : state.label_name,
                    option: mappedOptions,
                    subFilterType: state.label_query,
                    value: state.label_value,
                }
            })
            setFilterState(filteredArray)
        } else {
            setFilterState([])
        }
    }, [queryKey, data])


    // card outside click handler
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("[data-dropdown]") &&
                !event.target.closest("[data-options-button]")
            ) {
                setActiveCard(null)
            }
        }
        document.addEventListener("click", handleClickOutside)
        return () => document.removeEventListener("click", handleClickOutside)
    }, [])


    // if no permission for the module then just show the authorization card only
    if (!companyGrants?.isView) {
        return <div style={{ position: "absolute", left: "40%", top: "10rem" }}>
            <AuthorizationCard></AuthorizationCard>
        </div>
    }

    return (
        <div className="container-fluid d-flex flex-column px-0">

            {/* comapany full heading div */}
            <CompanyHeader
                viewMode={currView}
                // lastHeading={lastHeading}
                heading={heading}
                setHeading={setHeading}
                showCards={showCards}
                setShowCards={setShowCards}
                filterCategories={filterCategories}
                setFilterCategories={setFilterCategories}
                setSearch={setSearch}
                setActiveOffset={setActiveOffset}
                setTempFilterData={setTempFilterData}
                setCurrAdvFilter={setCurrAdvFilter}
                columnOptions={columnOptions}
                filterStates={filterStates}
                setFilterState={setFilterState}
                columns={columns}
                setColumns={setColumns}
                dropdownOptions={dropdownOptions}
                setShowCreateCompany={setShowCreateCompany}
                setCustomFilter={setCustomFilter}
                setCurrView={setCurrView}
                companyMetadata={companyMetadata}
                filterDropdown={filterDropdown}
                setFilterDropdown={setFilterDropdown}
                filterValues={companyFilterValues?.filter_state}
                setCompanyFilterValues={setCompanyFilterValues}
            />

            <CompanyHeaderCards
                showCards={showCards}
                customerId={customerId}
                loginUserId={loginUserId}
                headers={headers}
                extras={extras}
            />

            <CompanyListing
                columnOptions={columnOptions}
                columns={columns}
                highlightId={highlightId}
                data={data && data?.data}
                viewMode={currView}
                refetchCompanies={refetch}
                isLoading={isLoading || tempFilterDataLoading}
                tempFilterData={tempFilterData}
                limit={limit}
                setLimit={setLimit}
                headers={headers}
                extras={extras}
                activeOffset={activeOffset}
                setActiveOffset={setActiveOffset}
                totalCompanies={data?.total_count}
            />
            {
                showCreateCompany &&
                <CreateCompany
                    setHighlightId={setHighlightId}
                    refetchCompanies={refetch}
                    show={showCreateCompany}
                    setShow={setShowCreateCompany}
                />

            }
        </div>
    )
}